import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "align"];
import styled from 'foundations-theming/utils';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledMediaBody = styled.div.withConfig({
  displayName: "MediaBody__StyledMediaBody"
})(({
  $alignItems,
  $cssStyles
}) => {
  return Object.assign({
    flex: '1',
    order: '2',
    minInlineSize: '0',
    alignItems: $alignItems
  }, $cssStyles);
});

/**
 * CHANGE:
 * - `size` prop removed as it is not used outside of UIComponents.
 */

export const MediaBody = _ref => {
  let {
      children,
      align
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledMediaBody, Object.assign({
    $alignItems: align,
    $cssStyles: cssStyles
  }, domProps, {
    children: children
  }));
};
MediaBody.displayName = 'MediaBody';